/**
 * Returned – Cart drawer + Quick add (vanilla JS, inga beroenden)
 * Byggd för Empire 11.x. All interaktion via AJAX (/cart/*.js).
 *
 * Publika hooks:
 *  - [data-rtd-open-cart]                Öppnar drawern
 *  - [data-rtd-quick-add="VARIANT_ID"]   Lägger varianten direkt i varukorgen
 *  - [data-rtd-quick-pick="HANDLE"]      Öppnar variantväljaren för produkten
 *  - form[action*="/cart/add"]           Fångas upp och AJAX:as (PDP & quickshop)
 *  - document-event "rtd:cart:updated"   detail = cart JSON
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var SETTINGS = window.RTD_CART_SETTINGS || {};
  var MONEY_FORMAT = SETTINGS.moneyFormat || '{{amount_no_decimals}} kr';
  var CROSS_SELL_LIMIT = SETTINGS.crossSellLimit || 4;
  var openerBeforeDrawer = null;

  /* ---------------------------------------------------------- utils */

  function formatMoney(cents, format) {
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || MONEY_FORMAT;

    function withSep(num, precision) {
      var fixed = (num / 100).toFixed(precision);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return parts.join(',');
    }

    switch ((fmt.match(placeholderRegex) || [])[1]) {
      case 'amount': value = withSep(cents, 2); break;
      case 'amount_no_decimals': value = withSep(cents, 0); break;
      case 'amount_with_comma_separator': value = withSep(cents, 2); break;
      case 'amount_no_decimals_with_comma_separator': value = withSep(cents, 0); break;
      default: value = withSep(cents, 0);
    }
    return fmt.replace(placeholderRegex, value);
  }

  function el(tag, cls, html) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (html != null) node.innerHTML = html;
    return node;
  }

  function imgUrl(src, width) {
    if (!src) return '';
    var clean = src.split('?')[0];
    return clean + '?width=' + (width || 240);
  }

  function request(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign(
      { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      opts.headers || {}
    );
    return fetch(url, opts).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) { var e = new Error(json.description || json.message || 'Cart error'); e.payload = json; throw e; }
        return json;
      });
    });
  }

  var Cart = {
    get: function () { return request('/cart.js'); },
    add: function (items) { return request('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: items }) }); },
    change: function (line, quantity) { return request('/cart/change.js', { method: 'POST', body: JSON.stringify({ line: line, quantity: quantity }) }); }
  };

  /* ---------------------------------------------------------- drawer */

  var drawer = document.querySelector('[data-rtd-cart-drawer]');
  var overlay = document.querySelector('[data-rtd-cart-overlay]');
  if (!drawer || !overlay) return;

  var itemsHost = drawer.querySelector('[data-rtd-cart-items]');
  var footer = drawer.querySelector('[data-rtd-cart-footer]');
  var subtotalHost = drawer.querySelector('[data-rtd-cart-subtotal]');
  var countHosts = function () { return document.querySelectorAll('[data-rtd-cart-count]'); };
  var emptyHost = drawer.querySelector('[data-rtd-cart-empty]');
  var crossSellHost = drawer.querySelector('[data-rtd-cross-sell]');
  var liveRegion = drawer.querySelector('[data-rtd-cart-live]');

  function announce(msg) { if (liveRegion) { liveRegion.textContent = ''; liveRegion.textContent = msg; } }

  function setOpen(open) {
    drawer.classList.toggle('is-open', open);
    overlay.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    root.classList.toggle('rtd-scroll-lock', open);
    if (open) {
      openerBeforeDrawer = document.activeElement;
      window.requestAnimationFrame(function () {
        var target = drawer.querySelector('[data-rtd-cart-close]');
        if (target) target.focus();
      });
      document.addEventListener('keydown', onKeydown);
    } else {
      document.removeEventListener('keydown', onKeydown);
      if (openerBeforeDrawer && openerBeforeDrawer.focus) openerBeforeDrawer.focus();
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { setOpen(false); return; }
    if (e.key !== 'Tab') return;
    var focusables = drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function renderItem(item, index) {
    var li = el('li', 'rtd-cart-item');
    li.dataset.line = index + 1;

    var compare = item.original_line_price > item.final_line_price
      ? '<s class="rtd-cart-item__compare">' + formatMoney(item.original_line_price) + '</s>'
      : '';

    var variantTitle = item.product_has_only_default_variant || item.variant_title === 'Default Title'
      ? ''
      : '<p class="rtd-cart-item__variant">' + item.variant_title + '</p>';

    li.innerHTML =
      '<a class="rtd-cart-item__media" href="' + item.url + '" tabindex="-1" aria-hidden="true">' +
        (item.featured_image && item.featured_image.url
          ? '<img src="' + imgUrl(item.featured_image.url, 240) + '" alt="" loading="lazy" width="96" height="120">'
          : '') +
      '</a>' +
      '<div class="rtd-cart-item__info">' +
        '<a class="rtd-cart-item__title" href="' + item.url + '">' + item.product_title + '</a>' +
        variantTitle +
        '<div class="rtd-cart-item__price">' + compare +
          '<span>' + formatMoney(item.final_line_price) + '</span>' +
        '</div>' +
        '<div class="rtd-cart-item__controls">' +
          '<div class="rtd-qty" data-rtd-qty>' +
            '<button type="button" class="rtd-qty__btn" data-rtd-qty-minus aria-label="Minska antal">&minus;</button>' +
            '<span class="rtd-qty__value" aria-live="polite">' + item.quantity + '</span>' +
            '<button type="button" class="rtd-qty__btn" data-rtd-qty-plus aria-label="Öka antal">+</button>' +
          '</div>' +
          '<button type="button" class="rtd-cart-item__remove" data-rtd-remove aria-label="Ta bort ' + item.product_title + '">Ta bort</button>' +
        '</div>' +
      '</div>';
    return li;
  }

  function render(cart) {
    countHosts().forEach(function (host) {
      host.textContent = cart.item_count;
      host.classList.toggle('is-empty', cart.item_count === 0);
    });

    // Synka Empires header-bubbla (CSS läser attributet)
    document.querySelectorAll('[data-header-cart-count]').forEach(function (host) {
      host.setAttribute('data-header-cart-count', cart.item_count > 0 ? cart.item_count : '');
      host.classList.toggle('visible', cart.item_count > 0);
    });

    itemsHost.innerHTML = '';
    var hasItems = cart.items.length > 0;
    emptyHost.hidden = hasItems;
    footer.hidden = !hasItems;
    itemsHost.hidden = !hasItems;

    cart.items.forEach(function (item, i) { itemsHost.appendChild(renderItem(item, i)); });
    subtotalHost.textContent = formatMoney(cart.items_subtotal_price);

    document.dispatchEvent(new CustomEvent('rtd:cart:updated', { detail: cart }));
    if (hasItems) loadCrossSell(cart);
    else if (crossSellHost) { crossSellHost.hidden = true; }
  }

  function refresh() { return Cart.get().then(render); }

  /* ------------------------------------------------------ cross-sell */

  var crossSellLoadedFor = null;

  function loadCrossSell(cart) {
    if (!crossSellHost) return;
    var firstId = cart.items[0].product_id;
    if (crossSellLoadedFor === firstId) { crossSellHost.hidden = false; return; }

    var inCart = cart.items.map(function (i) { return i.product_id; });

    fetch('/recommendations/products.js?product_id=' + firstId + '&limit=' + (CROSS_SELL_LIMIT + inCart.length))
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var products = (data.products || [])
          .filter(function (p) { return p.available && inCart.indexOf(p.id) === -1; })
          .slice(0, CROSS_SELL_LIMIT);

        var list = crossSellHost.querySelector('[data-rtd-cross-sell-list]');
        list.innerHTML = '';
        if (!products.length) { crossSellHost.hidden = true; return; }

        products.forEach(function (p) {
          var single = p.variants.length === 1;
          var card = el('div', 'rtd-xsell__card');
          card.innerHTML =
            '<a class="rtd-xsell__media" href="' + p.url + '" tabindex="-1" aria-hidden="true">' +
              (p.featured_image ? '<img src="' + imgUrl(p.featured_image, 200) + '" alt="" loading="lazy" width="80" height="100">' : '') +
            '</a>' +
            '<div class="rtd-xsell__info">' +
              '<a class="rtd-xsell__title" href="' + p.url + '">' + p.title + '</a>' +
              '<span class="rtd-xsell__price">' +
                (p.compare_at_price > p.price ? '<s>' + formatMoney(p.compare_at_price) + '</s> ' : '') +
                formatMoney(p.price) +
              '</span>' +
            '</div>' +
            '<button type="button" class="rtd-xsell__add" ' +
              (single ? 'data-rtd-quick-add="' + p.variants[0].id + '"' : 'data-rtd-quick-pick="' + p.handle + '"') +
              ' aria-label="Lägg till ' + p.title + '">+</button>';
          list.appendChild(card);
        });
        crossSellLoadedFor = firstId;
        crossSellHost.hidden = false;
      })
      .catch(function () { crossSellHost.hidden = true; });
  }

  /* ------------------------------------------------- variant picker */

  var picker = document.querySelector('[data-rtd-picker]');
  var pickerBody = picker ? picker.querySelector('[data-rtd-picker-body]') : null;
  var pickerProduct = null;

  function openPicker(handle, triggerBtn) {
    if (!picker) return;
    setBusy(triggerBtn, true);
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        // En-variantsprodukter läggs direkt i varukorgen utan väljare
        if (product && product.variants && product.variants.length === 1) {
          addAndOpen([{ id: product.variants[0].id, quantity: 1 }], triggerBtn);
          return;
        }
        pickerProduct = product;
        renderPicker(product);
        picker.classList.add('is-open');
        overlay.classList.add('is-open');
        picker.setAttribute('aria-hidden', 'false');
        root.classList.add('rtd-scroll-lock');
        var firstInput = picker.querySelector('input[type="radio"]:not(:disabled)');
        if (firstInput) firstInput.focus();
      })
      .finally(function () { setBusy(triggerBtn, false); });
  }

  function closePicker() {
    if (!picker) return;
    picker.classList.remove('is-open');
    picker.setAttribute('aria-hidden', 'true');
    if (!drawer.classList.contains('is-open')) {
      overlay.classList.remove('is-open');
      root.classList.remove('rtd-scroll-lock');
    }
    pickerProduct = null;
  }

  function selectedOptions() {
    var values = [];
    pickerBody.querySelectorAll('[data-rtd-option-group]').forEach(function (group) {
      var checked = group.querySelector('input:checked');
      values.push(checked ? checked.value : null);
    });
    return values;
  }

  function findVariant(values) {
    if (!pickerProduct) return null;
    return pickerProduct.variants.find(function (v) {
      return v.options.every(function (opt, i) { return values[i] === opt; });
    }) || null;
  }

  function renderPicker(product) {
    var title = picker.querySelector('[data-rtd-picker-title]');
    var image = picker.querySelector('[data-rtd-picker-image]');
    var price = picker.querySelector('[data-rtd-picker-price]');

    title.textContent = product.title;
    image.innerHTML = product.featured_image
      ? '<img src="' + imgUrl(product.featured_image, 300) + '" alt="" width="120" height="150">' : '';
    price.innerHTML =
      (product.compare_at_price > product.price ? '<s>' + formatMoney(product.compare_at_price) + '</s> ' : '') +
      '<span>' + formatMoney(product.price) + '</span>';

    pickerBody.innerHTML = '';
    product.options.forEach(function (option, idx) {
      // /products/x.js kan ge options som strängar eller {name, values}-objekt
      var optionName = option && option.name ? option.name : option;
      var group = el('fieldset', 'rtd-picker__group');
      group.setAttribute('data-rtd-option-group', '');
      group.innerHTML = '<legend class="rtd-picker__legend">' + optionName + '</legend>';
      var values = [];
      product.variants.forEach(function (v) {
        if (values.indexOf(v.options[idx]) === -1) values.push(v.options[idx]);
      });
      var wrap = el('div', 'rtd-picker__options');
      values.forEach(function (value) {
        var available = product.variants.some(function (v) { return v.options[idx] === value && v.available; });
        var id = 'rtd-opt-' + idx + '-' + value.replace(/\W+/g, '-');
        var label = el('label', 'rtd-picker__chip' + (available ? '' : ' is-soldout'));
        label.innerHTML =
          '<input type="radio" id="' + id + '" name="rtd-option-' + idx + '" value="' + value.replace(/"/g, '&quot;') + '"' + (available ? '' : ' data-soldout="1"') + '>' +
          '<span>' + value + '</span>';
        wrap.appendChild(label);
      });
      group.appendChild(wrap);
      pickerBody.appendChild(group);
    });

    updatePickerState();
  }

  function updatePickerState() {
    var addBtn = picker.querySelector('[data-rtd-picker-add]');
    var values = selectedOptions();
    var complete = values.every(function (v) { return v !== null; });
    var variant = complete ? findVariant(values) : null;

    if (variant) {
      var price = picker.querySelector('[data-rtd-picker-price]');
      price.innerHTML =
        (variant.compare_at_price > variant.price ? '<s>' + formatMoney(variant.compare_at_price) + '</s> ' : '') +
        '<span>' + formatMoney(variant.price) + '</span>';
    }

    addBtn.disabled = !variant || !variant.available;
    addBtn.textContent = !complete ? 'Välj ' + nextMissingOption(values)
      : (variant && variant.available ? 'Lägg i varukorg' : 'Slutsåld');
    addBtn.dataset.variantId = variant ? variant.id : '';
  }

  function nextMissingOption(values) {
    var idx = values.indexOf(null);
    if (!pickerProduct || idx < 0) return 'variant';
    var o = pickerProduct.options[idx];
    return String(o && o.name ? o.name : o).toLowerCase();
  }

  /* ------------------------------------------------------ behaviors */

  function setBusy(btn, busy) {
    if (!btn) return;
    btn.classList.toggle('is-busy', !!busy);
    btn.disabled = !!busy;
  }

  function addAndOpen(items, btn) {
    setBusy(btn, true);
    return Cart.add(items)
      .then(function () { return refresh(); })
      .then(function () {
        closePicker();
        setOpen(true);
        announce('Produkten lades i varukorgen.');
        if (btn) {
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
        }
      })
      .catch(function (e) {
        announce(e.message || 'Något gick fel. Försök igen.');
        if (btn) {
          btn.classList.add('is-error');
          setTimeout(function () { btn.classList.remove('is-error'); }, 1600);
        }
      })
      .finally(function () { setBusy(btn, false); });
  }

  document.addEventListener('click', function (e) {
    var t;

    if ((t = e.target.closest('[data-rtd-quick-add]'))) {
      e.preventDefault();
      addAndOpen([{ id: parseInt(t.getAttribute('data-rtd-quick-add'), 10), quantity: 1 }], t);
      return;
    }

    if ((t = e.target.closest('[data-rtd-quick-pick]'))) {
      e.preventDefault();
      openPicker(t.getAttribute('data-rtd-quick-pick'), t);
      return;
    }

    if ((t = e.target.closest('[data-rtd-picker-add]'))) {
      var vid = parseInt(t.dataset.variantId, 10);
      if (vid) addAndOpen([{ id: vid, quantity: 1 }], t);
      return;
    }

    if (e.target.closest('[data-rtd-picker-close]')) { closePicker(); return; }

    if ((t = e.target.closest('[data-rtd-open-cart]'))) { e.preventDefault(); refresh().then(function () { setOpen(true); }); return; }
    if (e.target.closest('[data-rtd-cart-close]')) { setOpen(false); return; }
    if (e.target === overlay) { closePicker(); setOpen(false); return; }

    var lineEl = e.target.closest('.rtd-cart-item');
    if (lineEl) {
      var line = parseInt(lineEl.dataset.line, 10);
      var qtyValue = lineEl.querySelector('.rtd-qty__value');
      var current = parseInt(qtyValue.textContent, 10);
      if (e.target.closest('[data-rtd-qty-plus]')) { Cart.change(line, current + 1).then(render); }
      else if (e.target.closest('[data-rtd-qty-minus]')) { Cart.change(line, Math.max(0, current - 1)).then(render); }
      else if (e.target.closest('[data-rtd-remove]')) { Cart.change(line, 0).then(render).then(function () { announce('Produkten togs bort.'); }); }
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-rtd-picker]')) updatePickerState();
  });

  // AJAX:a PDP-/quickshop-formulär
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || form.hasAttribute('data-rtd-native')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var fd = new FormData(form);
    var id = parseInt(fd.get('id'), 10);
    var qty = parseInt(fd.get('quantity') || '1', 10);
    if (!id) return;
    addAndOpen([{ id: id, quantity: qty }], btn);
  });

  // Header-kundvagnslänken öppnar drawern istället för /cart
  document.querySelectorAll('a[href="/cart"], a[href$="/cart"]').forEach(function (link) {
    if (link.closest('[data-rtd-cart-drawer]')) return;
    link.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      refresh().then(function () { setOpen(true); });
    });
  });

  // Publikt API (används bl.a. av wishlist)
  window.RTDCart = {
    open: function () { return refresh().then(function () { setOpen(true); }); },
    close: function () { setOpen(false); },
    refresh: refresh
  };

  refresh();
})();
